import { Button, Modal } from "react-bootstrap";
import {
  generateForm, generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../appContext/AppContext";
import { XayDungKeHoachContext } from "../HoiChanKhamBenh";
import { Formik, Form } from "formik";
import { addPhieuKeHoach, updatePhieuKeHoach } from "../services/services";
import { CODE, TYPE_WH } from "../../../../utils/Constant";
import { toast } from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import { IconButtonSave } from "../../../../component/IconSvg";
import { formatDateDTO } from "../../../../utils/FormatUtils";
import { TypeKeHoach } from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import { searchdsNhanSu } from "../../ho-tro-ky-thuat/services/services";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  type: TypeKeHoach;
}

const DialogBienBanHoiChan = (props: Props) => {
  const { show, onHide, setInitialValues, initialValues, type } = props;
  const { setIsLoading } = useContext(AppContext);
  const { dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach } = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [dataTable, setDataTable] = useState<any>({
    batchStaffList: []
  });
  const getDsItems = async () => {
    try {
      const data = await searchdsNhanSu(initialValues?.id);
      setDataTable({ batchStaffList: data?.data?.data ?? [] })
    } catch (e) {
      console.error("Lỗi khi tải danh sách nhân sự:", e);
    }
  }

  useEffect(() => {
    initialValues?.id && getDsItems();
  }, [initialValues?.id]);

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values[type.formThongTinChung],
      type: TYPE_WH.IMPORT,
      doCreation: values?.[type.formThongTinChung]?.id ? formatDateDTO(values?.[type.formThongTinChung]?.doCreation) : formatDateDTO(new Date()),
      listOfInstructions: [...(dsKeHoach || [])].map(item => {
        return (
          {
            ...item,
            id: item?.id || null,
          }
        )
      }),
      ...dataTable,
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };
    try {
      setIsLoading(true);
      const id = values[type.formThongTinChung]?.id;
      const { data } = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        toast.success(((id) ? "Cập nhật" : "Thêm") + " thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateForm();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({ ...generateInitValues(data), ...initialValues })
  };

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{ [type.formThongTinChung]: initialValues }}
        validationSchema={generateValidationSchema(listJsonGenerate, type.formThongTinChung)}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <ModelHeader onHide={onHide} title={type.name} />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces px-10">
                <GenerateFormComponent
                  listFieldAuto={listJsonGenerate}
                  handleChange={handleChange}
                  setValues={setValues}
                  values={values}
                  touched={touched}
                  errors={errors}
                  lstSelectedRenderButton={dsKeHoach}
                  setFieldValue={setFieldValue}
                  modelID={type.formThongTinChung}
                  customComponent={DynamicComponent}
                />
              </div>

            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
              {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                <WfButton
                  additionalFunc={(data: any) => {
                    setDetailPhieuKeHoach({
                      ...detailPhieuKeHoach,
                      status: data?.currCode,
                      statusCode: data?.currCode,
                      statusId: data?.currId,
                    })
                  }}
                  afterSubmit={() => {
                    handleFormSubmit(values)
                  }}
                  handleClick={(data: any) => {
                    data.code === "approved_done" && setIsView(true);
                  }}
                  onHide={onHide}
                  tracker={type.trackerCode}
                  objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                />
              )}
              {!isView &&
                <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave /> Lưu
                </Button>
              }
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogBienBanHoiChan;
